import React from 'react';
//hook
import useComnHook from 'src/webapp/hooks/comn/comn.hook';

export default function MarketRegDataFieldInputField(props) {
    const { type, inputRef, propRef, value, placeholder, setInputValid, change } = props;//props
    /* =============== noti!! =============== */
    /* change - 1.숫자 + 콤마, 2.숫자만 입력       */
    /* =============== noti!! =============== */
    const { onNumberCommaHandler, onPhoneNumberFormatHandler, onDoubleCommahandler } = useComnHook();

    /* =============== 입력값검증 =============== */
    const onValidateHandler = (e) => {
        if(change !== undefined) {
            switch(change) {
                case 1 : onNumberCommaHandler(e); break;
                case 2 : onPhoneNumberFormatHandler(e); break;
                case 3 : onDoubleCommahandler(e); break;
            }
        }
        let valid = true;
        for(let i = 0; i < inputRef.current.length; i++) {
            if(i !== 2 && i !== 4) { 
                if(inputRef.current[i]?.value.length <= 0) { valid = false; break;  }
            }
        }
        setInputValid(valid);
    }
    /* =============== 입력값검증 =============== */

    return (
        <>
        {type === 1 ?
            <input type='text' ref={propRef} defaultValue={value} placeholder={placeholder} onChange={(e) => onValidateHandler(e)} />
        : type === 2 ?
            <textarea ref={propRef} defaultValue={value} placeholder={placeholder} onChange={(e) => onValidateHandler(e)}></textarea>
        : null}
        {/* {type === 1 ?
            <input type='text' ref={propRef} defaultValue={value} placeholder={placeholder} onChange={(e) => {onValidateHandler();onChange(e);onValid();}} />
        : type === 2 ?
            <textarea ref={propRef} defaultValue={value} placeholder={placeholder} onChange={(e) => {onValidateHandler();onValid();}}></textarea>
        : null} */}
        </>
    );
}